import React from 'react';
import { Alert, Button } from '@mui/material';

/**
 * Inline success line for the add that just landed, with its undo.
 *
 * An inline `Alert` rather than a floating Snackbar so it appears where the user
 * is already looking — at the tile they just clicked — and `role="status"` so the
 * add is announced WITHOUT moving focus. Focus staying on the tile is what makes
 * repeat adds work by keyboard.
 *
 * @param {Object}   props
 * @param {string}   props.message
 * @param {Function} props.onUndo
 * @param {boolean}  [props.undoDisabled]
 * @param {string}   [props.undoDisabledReason]
 */
const AddConfirmation = ({
  message,
  onUndo,
  undoDisabled = false,
  undoDisabledReason = ''
}) => (
  <Alert
    role="status"
    severity="success"
    sx={{ mt: 1.5, py: 0, fontSize: 12.5, alignItems: 'center' }}
    action={
      <Button
        size="small"
        color="inherit"
        onClick={onUndo}
        disabled={undoDisabled}
        title={undoDisabledReason || undefined}
        sx={{ fontSize: 12, textTransform: 'none' }}
      >
        Undo
      </Button>
    }
  >
    {message}
  </Alert>
);

export default AddConfirmation;
